module.exports = __webpack_public_path__ + "img/logo.0af6aac3.png";